import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { I18NextModule } from 'angular-i18next';
import { IconComponent } from 'src/app/common/icon/icon.component';
import {
  CarouselComponent,
  CarouselGrid,
  CarouselNext,
  CarouselPrev,
  CarouselTitle,
} from '../carousel/carousel.component';
import { ContentCardComponent } from '../content-card/content-card.component';
import { GtagService } from '../../../common/gtag/gtag.service';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'sharry-card-carousel',
  standalone: true,
  imports: [
    ContentCardComponent,
    MatButtonModule,
    IconComponent,
    I18NextModule,
    CarouselComponent,
    CarouselNext,
    CarouselPrev,
    CarouselTitle,
    NgTemplateOutlet,
    NgClass,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-carousel.component.html',
  styleUrls: ['./card-carousel.component.scss'],
})
export class CardCarouselComponent implements AfterViewInit {
  @Input() carouselTitle = '';
  @Input() carouselTitleClass = '';
  @Input() subtitle = '';
  @Input() contents: any[] = [];
  @Input() classes = '';
  @Input() mode: 'compact' | 'template' | 'regional-template' = 'compact';
  @Input() grid: CarouselGrid = { xs: 1, sm: 2, md: 3, lg: 4, xl: 4 };
  @Input() itemTemplate: TemplateRef<any>;
  @Input() usePagination = false;
  @Input() total: number;
  @Output() carouselClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() next: EventEmitter<void> = new EventEmitter<void>();
  @Output() prev: EventEmitter<void> = new EventEmitter<void>();
  @Output() carouselWheel: EventEmitter<void> = new EventEmitter<void>();

  constructor(private gtagService: GtagService) {}

  ngAfterViewInit(): void {
    const items = this.contents.map((card: any) => ({
      item_name: card?.title,
      item_id: card?.id,
      ...(card?.contentType === 'sharry' && { price: card?.nextUpcomingVariant?.discountedPrice }),
      item_brand:
        card?.__typename === 'FeaturedCard'
          ? 'Ruralis'
          : card?.contentType === 'wonder'
            ? 'Wonder'
            : card?.owner?.businessName,
      item_category: card?.sharryKind?.name,
      item_variant: card?.sharrySelection,
    }));
    this.gtagService.pushEvent(
      {
        event: 'view_item_list',
        ecommerce: {
          items: items,
        },
      },
      true,
    );
  }

  onChangedBookmarked($event: any) {
    this.contents = this.contents.map(card =>
      card.id === $event.id ? { ...card, bookmarked: $event.bookmarked } : card,
    );
  }
}
